module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0008.df1c8ab8.png";